export const LABELS = {
  KNOWLEDGE: 'Knowledge',
  RAG_SEARCH: 'RAG Search',
  DATA_SOURCE: 'Data Source',
  ACTIVATE: 'Activate',
  RENAME: 'Rename',
  DELETE: 'Delete',
  DEACTIVATE: 'Deactivate',
  CHUNK_VIEWER: 'Chunk Viewer',
  DOWNLOAD: 'Download',
  NAME: 'Name',
  STATUS: 'Status',
  FILE_SIZE: 'File Size',
  CREATED: 'Created',
  ADD_DATA_SOURCE: 'Add Data Source',
  RENAME_SOURCE: 'Rename Source',
  ACTIVATE_DATA_SOURCE: 'Activate Data Source',
  NO_DATA_YET: 'There are no Data yet.',
  DELETE_SOURCE_CONFIRMATION: 'Do you want to delete this source?',
  SEARCH_PLACEHOLDER: 'Search',
  EDIT_CHUNK: 'Edit',
  EDIT_CHUNK_TITLE: 'Edit Chunk',
} as const;

export const TABLE_CONFIG = {
  PER_PAGE: 10,
  EMPTY_MESSAGE: LABELS.NO_DATA_YET,
} as const;

export const SOURCE_STATUS = {
  ACTIVE: 'active',
  IN_PROGRESS: 'in_progress',
  INACTIVE: 'inactive',
} as const;

export const PROCESSING_STATUSES = [
  'running',
  'pending',
  'Processing',
] as const;

export const FILE_TYPES = {
  JSON: 'JSON',
} as const;

export const MODAL_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  BIG: 'big',
} as const;

export const DATE_FORMAT = 'dd MMM yyyy' as const;

export const ACTION_TYPES = {
  RENAME: 'rename',
  DELETE: 'delete',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
  DETAILS: 'details',
  DOWNLOAD: 'download',
} as const;

export const SORT_FIELDS = {
  NAME: 'name',
  STATUS: 'status',
  FILE_SIZE: 'file_size',
  CREATED_AT: 'created_at',
} as const;

export const DATE_FORMAT_OPTIONS = {
  DAY: '2-digit',
  MONTH: 'short',
  YEAR: 'numeric',
} as const;
